import { render, staticRenderFns } from "./index.vue?vue&type=template&id=701fd1ab&scoped=true&"
import script from "./index.ts?vue&type=script&lang=js&"
export * from "./index.ts?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=701fd1ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fd1ab",
  null
  
)

export default component.exports